import { useState, useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
  useHistory,
} from "react-router-dom";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Container,
} from "reactstrap";
import swal from "sweetalert";
import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import { AgGridReact, AllCommunityModules, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import { userService } from "../../../services/authentication";
import { usermanageService } from "../../../services/usermanageService";
import { taskmanageService } from "../../../services/taskmanageService";
import "../../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { ExitStatus, forEachChild } from "typescript";
import { connect } from "react-redux";
import DataTable from "react-data-table-component";
import Buttoncomponent from 'components/Buttoncomponent.js';
import Select from 'react-select';

const AddRoleChangeLog = (props) => {
  const [userdatas, setUserdatad] = useState([]);
  const [user_roles, setUserroles] = useState([]);
  const [user_phases, setUserphase] = useState([]);
  const [inputFields, setInputfields] = useState({});
  const [displayphase, setDisplayphase] = useState(false);
  const [userdata, setUserdata] = useState([]);
  const [atl_lists, setAtlLists] = useState([]);
  const [displayqatl, setDisplayqatl] = useState(false);
  const [displayclientqatl, setDisplayClientqatl] = useState(false);
  const [displayatl, setDisplayatl] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
 
  function inputhandler1(e) {
    setSelectedUser(e);
    let phseup = {}
    phseup = {...inputFields,'user':e.value}
    
    setInputfields(phseup);
  }
  function inputhandler(e) {
    console.log(e)
    let phseup = {}
    if(Array.isArray(e)){     
      phseup = {...inputFields,qatl : Array.isArray(e) ? e.map(x => x.value) : []}
    }else{
      if(e.target.name == 'roles'){
        getqatl_list(e.target.value);
        
      }
        phseup = { ...inputFields, [e.target.name]: e.target.value }    
      
    }
    setInputfields(phseup);
    
    // console.log(inputFields);
  }

  useEffect(() => {
    getuser_list();
   // getqatl_list();
    return () => {
      setInputfields({});
    };
  }, []);

  function getuser_list() {
    usermanageService.getuserswithoutClient().then((response) => {
      console.log(response);
      setUserroles(response.data.corient_roles);
      setUserdata(response.data.corient_role_users);
    });
  }

  function getqatl_list(id) {
    usermanageService.getUserListforassign(id).then((response) => {
  
        const selectdata = {roles:id,qatl: (response.data.data) ? response.data.data.map(x => x.id) : []}
        console.log(selectdata)
        setInputfields(selectdata)
        console.log(inputFields)
      });
  }

  const assignmanager = () =>{
    history.push({
      pathname: 'assignmanager',
    });
  }
  function SaveData(e){
    e.preventDefault();
    // console.log(inputFields);
    // return;
    usermanageService.addRoleChangeLog(inputFields).then((response)=>{
      if(response.status == 200){
         toast.success(response.data.message); 
         document.getElementById("adduser-form").reset();
         setInputfields({});
         setSelectedUser(null); 
      }else{
        console.log(response.data);
         toast.error(response.data.message);
      }
    });
  }
  const styles = {
    'color':'#4a4444',
  };
  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <div className="row">
          <div className="col-xl-12">
            <div className="col-md-12 col-12">
              <div class="row">
                  <div class="col-md-6"><h2>Add Change Role</h2></div>
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-2 offset-md-10">
                        <Buttoncomponent/>
                      </div>
                    </div>
                  </div>
                </div>
                <br/>
              <Card className="card">
              <Form role="form" id="adduser-form" onSubmit={SaveData}>
                <div className="row">
                    
                     
                <div className="col-md-4" >
                      
                      <FormGroup>
                            <Select 
                            className="input-group-alternative mb-3" 
                            name="user" 
                            options={userdata} 
                            onChange={inputhandler1}
                            value={selectedUser}
                            isClearable
                            required
                          />
                          
                        </FormGroup>
                    </div>
    
                </div>
                <div className="row">
                <div className="col-md-4">
                        <FormGroup>
                          <InputGroup className="input-group-alternative mb-3">
                            <select className="form-control" name="role_id" onChange={inputhandler} placeholder="Role" required>
                              <option key="role_1"  value="">Select role</option>
                              {user_roles.map(roles =>
                                  <option key={roles.role_id} value={roles.role_id}>{roles.role_name}</option>
                              )}
                            </select>
                          </InputGroup>
                        </FormGroup>
                    </div>
                    </div>
                <div className="row">
                                  <div className="col-xl-4 col-md-4 col-xs-12" >
                                  <h3 className="clientformtag">From date</h3>
                                  <InputGroup className="input-group-alternative mb-3">
                                    <Input
                                      placeholder="From Date"
                                      type="date"
                                      name="from_date"
                                      
                                      onChange={inputhandler}
                                      required
                                    />
                                  </InputGroup>
                                  </div>
                                  <div className="col-xl-4 col-md-4 col-xs-12" >
                                  <h3 className="clientformtag">To date</h3>
                                  <InputGroup className="input-group-alternative mb-3">
                                    <Input
                                      placeholder="To Date"
                                      type="date"
                                      name="to_date"
                                      
                                      onChange={inputhandler}
                                      
                                    />
                                  </InputGroup>
                                  </div>
                                  </div>
                <div class="row">
                <div className="col-md-4">
                        
                          <Button className="col-12 " color="primary" type="submit">
                            Save
                         </Button>
                    </div>
                    
                </div>
                
                <FormGroup>
                  <InputGroup className="input-group-alternative mb-3"></InputGroup>
                </FormGroup>
                </Form>
              </Card>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default AddRoleChangeLog;
